import { enUS } from 'date-fns/locale';
import { startOfWeek as dfnsStartOfWeek } from 'date-fns';

export const startOfWeek = (date: Date, locale = enUS) => {
  return dfnsStartOfWeek(date, { weekStartsOn: 1 });
};
